module.exports = __webpack_public_path__ + "img/226.4e5c5d21.jpg";